import styled from 'styled-components';

export const InputLabel = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	margin-bottom: 0;
`;
